import * as React from 'react';
import CatalogShopAllTable from "./catalogShopAllTable";

export default function CatalogShopAllHome(props) {

    return (
        <CatalogShopAllTable/>
    )
}